// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1FskQ","name":"Footer_name__2tLw3","iconContainer":"Footer_iconContainer__ss6Rd"};